import React, { useState } from 'react';
import MediaViewerModal from './MediaViewerModal';

/**
 * Кнопка-іконка для відкриття {@link MediaViewerModal}.
 * Тримає власний `open`-стан — коротка обгортка для простих випадків
 * (одна кнопка = один тригер), на відміну від {@link MediaViewerModal},
 * який розрахований на один спільний екземпляр на багато тригерів.
 *
 * @param {Array<{media_id: number, name?: string, content_url: string, download_url?: string, file_size?: number}>} attachments
 * @param {number} [startIndex]
 * @param {boolean} [disabled]
 * @param {string} [title]
 * @param {string} [className] - додається до базового "custom-view-icon"
 */
const MediaViewerButton = ({ attachments = [], startIndex = 0, disabled = false, title = 'Переглянути вкладення', className = '' }) => {
	const [open, setOpen] = useState(false);
	const isDisabled = disabled || !attachments || attachments.length === 0;

	return (
		<>
			<button
				type="button"
				className={`custom-view-icon${className ? ` ${className}` : ''}`}
				title={title}
				onClick={() => setOpen(true)}
				disabled={isDisabled}
				style={{ background: 'none', cursor: isDisabled ? 'default' : 'pointer' }}
			>
				🖼{attachments.length > 0 ? ` ${attachments.length}` : ''}
			</button>
			<MediaViewerModal
				open={open}
				onClose={() => setOpen(false)}
				attachments={attachments}
				startIndex={startIndex}
			/>
		</>
	);
};

export default MediaViewerButton;
